import React from "react";
import PropTypes from "prop-types";
import ButtonIcon from "../buttons/buttonIcon";
import * as buttonConstants from "../buttons/buttonConstants";

const MetadataRow = ({ metadata, isEditing, onEditMetadata, onDeleteMetadata }) => {
    return (
        <tr>
            <td>
                {metadata.Key}
            </td>
            <td>
                {metadata.Value}
            </td>
            <td className={"text-center"}>
                <ButtonIcon config={{
                    disabled: isEditing,
                    name: "btnEdit",
                    label: "Edit",
                    onClick: onEditMetadata,
                    iconType: buttonConstants.ICON_EDIT
                }} />
                <ButtonIcon config={{
                    disabled: isEditing,
                    name: "btnDelete",
                    label: "Delete",
                    iconType: buttonConstants.ICON_DELETE,
                    onClick: onDeleteMetadata
                }} />
            </td>
        </tr>
    );
};

MetadataRow.propTypes = {
    metadata: PropTypes.object.isRequired,
    isEditing: PropTypes.bool.isRequired,
    onEditMetadata: PropTypes.func.isRequired,
    onDeleteMetadata: PropTypes.func.isRequired
};

export default MetadataRow;
